import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/commons';
import { ConfirmDeactivateGuard } from 'src/commons/guards';
import { AccountExtScreenComponent } from 'src/screens/accounting-distribution-external/account/account.component';
import { AccountingDistributionExternalScreenComponent } from 'src/screens/accounting-distribution-external/accounting-distribution-external.component';
import { CompanyExtScreenComponent } from 'src/screens/accounting-distribution-external/company/company.component';
import { ExpOrgExtScreenComponent } from 'src/screens/accounting-distribution-external/exp-org/exp-org.component';
import { ExpTypeExtScreenComponent } from 'src/screens/accounting-distribution-external/exp-type/exp-type.component';
import { OebsConfigExtScreenComponent } from 'src/screens/accounting-distribution-external/oebs-config/oebs-config.component';
import { ProjectTaskExtScreenComponent } from 'src/screens/accounting-distribution-external/project-task/project-task.component';
import { AdminScreenComponent } from 'src/screens/admin/admin.component';
import { AlmConfigurationScreenComponent } from 'src/screens/alm-configuration/alm-configuration.component';
import { CommunityGrantScreenComponent } from 'src/screens/community-grant/community-grant.component';
import { EinConfigurationScreenComponent } from 'src/screens/ein-configuration/ein-configuration.component';
import { EmailConfigurationScreenComponent } from 'src/screens/email-configuration/email-configuration.component';
import { EventSponsorshipScreenComponent } from 'src/screens/event-sponsorship/event-sponsorship.component';
import { ExternalUsersManagementScreenComponent } from 'src/screens/external-users-management/external-users-management.component';
import { ForgotPasswordComponent } from 'src/screens/forgot-password/forgot-password.component';
import { FormConfigurationScreenComponent } from 'src/screens/form-configuration/form-configuration.component';
import { FormStatusScreenComponent } from 'src/screens/form-status/form-status.component';
import { OverrideReportingScreenComponent } from 'src/screens/override-reporting/override-reporting.component';
import { PaymentCheckScreenComponent } from 'src/screens/payment-check/payment-check.component';
import { PaymentConfigScreenComponent } from 'src/screens/payment-config/payment-config.component';
import { PaymentCreditScreenComponent } from 'src/screens/payment-credit/payment-credit.component';
import { PaymentFoundationTrusteeScreenComponent } from 'src/screens/payment-foundation-trustee/payment-foundation-trustee.component';
import { PlantPlanetScreenComponent } from 'src/screens/plant-planet/plant-planet.component';
import { ProfileScreenComponent } from 'src/screens/profile/profile.component';
import { SetPasswordComponent } from 'src/screens/set-password/set-password.component';
import { CharitableContributionScreenComponent } from '../screens/charitable-contribution/charitable-contribution.component';
import { CharityFormsScreenComponent } from '../screens/charity-forms/charity-forms.component';
import { HomeScreenComponent } from '../screens/home/home.component';
import { LoginScreenComponent } from '../screens/login/login.component';
import { MatchingGiftScreenComponent } from '../screens/matching-gift/matching-gift.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
    // component: HomeScreenComponent,
  },
  // {
  //     path: '**',
  //     pathMatch: 'full',
  //     redirectTo: 'home'
  // },
  {
    path: 'home',
    component: HomeScreenComponent,
    canActivate: [AuthGuard],
    data: { screenName: 'Home' },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'login',
    component: LoginScreenComponent
  },
  {
    path: 'profile',
    component: ProfileScreenComponent,
    canActivate: [AuthGuard],
    data: { screenName: 'Profile' },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'login',
    component: LoginScreenComponent,
    canActivate: [AuthGuard],
    data: { screenName: 'Login' },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'set-password',
    data: { screenName: 'Password' },
    component: SetPasswordComponent,
  },
  {
    path: 'set-password/LOSTPASSWORD',
    component: SetPasswordComponent,
  },
  {
    path: 'forgot-password',
    data: { screenName: 'Password' },
    component: ForgotPasswordComponent,
  },
  {
    path: 'charity-forms',
    component: CharityFormsScreenComponent,
    data: { screenName: 'Grant Applications' },
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },

  {
    path: 'charity-forms/charitable-contribution',
    component: CharitableContributionScreenComponent,
    canActivate: [AuthGuard],
    data: { screenName: 'Charitable Contributions Application' },
    canDeactivate: [ConfirmDeactivateGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'charity-forms/charitable-contribution/:id',
    component: CharitableContributionScreenComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuard],
    data: { screenName: 'Charitable Contributions Application' },
    runGuardsAndResolvers: 'always',
  },

  {
    path: 'charity-forms/matching-gift',
    component: MatchingGiftScreenComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuard],
    data: { screenName: 'Matching Gift Application' },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'charity-forms/matching-gift/:id',
    component: MatchingGiftScreenComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuard],
    data: { screenName: 'Matching Gift Application' },
    runGuardsAndResolvers: 'always',
  },

  {
    path: 'charity-forms/community-grant',
    component: CommunityGrantScreenComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuard],
    data: { screenName: 'Community Grants Application' },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'charity-forms/community-grant/:id',
    component: CommunityGrantScreenComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuard],
    data: { screenName: 'Community Grants Application' },
    runGuardsAndResolvers: 'always',
  },

  {
    path: 'charity-forms/plant-planet',
    component: PlantPlanetScreenComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuard],
    data: {
      screenName: 'Plant for the Planet Matching Grant Program Application',
    },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'charity-forms/plant-planet/:id',
    component: PlantPlanetScreenComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuard],
    data: {
      screenName: 'Plant for the Planet Matching Grant Program Application',
    },
    runGuardsAndResolvers: 'always',
  },

  {
    path: 'charity-forms/event-sponsorship',
    component: EventSponsorshipScreenComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuard],
    data: { screenName: 'Event Sponsorship Application' },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'charity-forms/event-sponsorship/:id',
    component: EventSponsorshipScreenComponent,
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmDeactivateGuard],
    data: { screenName: 'Event Sponsorship Application' },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'admin',
    component: AdminScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'], screenName: 'Admin' },
  },
  {
    path: 'admin/payment-config',
    component: PaymentConfigScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'], screenName: 'Payment Configuration' },
  },
  {
    path: 'admin/override-reporting-hierarchy',
    component: OverrideReportingScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'], screenName: 'Override Reporting Hierarchy'  },
  },
  {
    path: 'admin/payment-check',
    component: PaymentCheckScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'], screenName: 'OeBS Check Payment' },
  },
  {
    path: 'admin/payment-credit',
    component: PaymentCreditScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'] , screenName: 'OeBS Credit Payment' },
  },
  {
    path: 'admin/payment-foundation-trustee',
    component: PaymentFoundationTrusteeScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'], screenName: 'Foundation Trustee Payment'  },
  },
  {
    path: 'admin/ein-configuration',
    component: EinConfigurationScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'], screenName: 'EIN Configuration'  },
  },
  {
    path: 'admin/form-configuration',
    component: FormConfigurationScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: {
      role: ['ADMIN', 'PFTPAPPROVER', 'FOUNDATIONAPPROVER', 'CITAPPROVER'], 
      screenName: 'Form Configuration' 
    },
  },
  {
    path: 'admin/alm-configuration',
    component: AlmConfigurationScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'], screenName: 'ALM Configuration'  },
  },
  {
    path: 'admin/external-users-management',
    component: ExternalUsersManagementScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'], screenName: 'External Users Management'  },
  },
  {
    path: 'admin/email-configuration',
    component: EmailConfigurationScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'], screenName: 'Email Configuration'  },
  },
  {
    path: 'admin/form-status',
    component: FormStatusScreenComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
    data: { role: ['ADMIN'], screenName: 'Award/Decline Requests' },
  },
  {
    path: 'admin/accounting-distribution-external',
    component: AccountingDistributionExternalScreenComponent,
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    data: { role: ['ADMIN'], screenName: 'Accounting Distribution Configuration' },
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: 'company',
        component: CompanyExtScreenComponent,
      },
      {
        path: 'org',
        component: ExpOrgExtScreenComponent,
      },
      {
        path: 'account',
        component: AccountExtScreenComponent,
      },
      {
        path: 'project-task',
        component: ProjectTaskExtScreenComponent,
      },
      {
        path: 'exp-type',
        component: ExpTypeExtScreenComponent,
      },
      {
        path: 'exp-org',
        component: ExpOrgExtScreenComponent,
      },
      {
        path: 'oebs-config',
        component: OebsConfigExtScreenComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [],
  exports: [RouterModule],
})
export class AppRoutingModule {}
